import React, { useContext } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import { vanillaRenderers, vanillaCells } from '@jsonforms/vanilla-renderers'
import PageControl, { pageControlTester } from './control/page/Control'
import { JsonForms } from '@jsonforms/react'
import FormLoading from 'components/Loader/FormLoading'

const PageLayout = ({ isOpenModal, schema = {}, uischema = {}, data }) => {
  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext

  const renderers = [
    ...vanillaRenderers,
    { tester: pageControlTester, renderer: PageControl },
  ]

  if (Object.keys(schema).length === 0) {
    return <FormLoading />
  }

  return (
    <JsonForms
      data={data}
      schema={schema || jsonForm.uischema}
      uischema={uischema || jsonForm.uischema}
      config={{ isOpenModal }}
      renderers={renderers}
      cells={vanillaCells}
    />
  )
}

export default PageLayout
